import { useSessionStore } from "@/entities/session";

export const useAuthUser = () => {
  const { user } = useSessionStore();

  if (!user) {
    throw Error("User is not logged in");
  }

  return user;
};
